import React, { Component } from 'react';
//import closeIcon from './../assets/close-icon.png';


class Header extends Component {

  render() {
    return (
      <div></div>
      // <div className="sc-header">
      //   <div className="sc-header--team-name"> {this.props.teamName} </div>  
      // </div>
    );
  }
}

export default Header;
